module.exports = __webpack_public_path__ + "img/truck_03.5d165e4c.jpg";